import ZApiClient from '../client/z-api-client';
const companyCategoriesClient = ZApiClient.getCompanyCategoriesClient();

export const getCompanyCategoryTitles = (fragment, params) => {
  if (!fragment) return companyCategoriesClient.getAllTitlesWithIds();
  return companyCategoriesClient.getAllTitlesWithIdsByNameFragment(fragment, params);
};
